import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Themes from '../manage/website/Themes';
import { PageListContainer } from '../manage/website/ManagePages';
import { fetchPages } from '../../actions/website/PageActions';
import { showModal, hideModal } from '../../actions/ModalActions';

class WebsiteOnboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1
    };
    this.getNextStep = this.getNextStep.bind(this);
    this.getPreviousStep = this.getPreviousStep.bind(this);
  }
  componentDidMount() {
    const { getPages } = this.props;
    getPages();
  }
  getNextStep() {
    this.setState({ step: this.state.step + 1 });
  }
  getPreviousStep() {
    this.setState({ step: this.state.step - 1 });
  }
  render() {
    const { launchSuccessModal } = this.props;
    return (
      <div>
        <header className="onboard-header text-center clearfix">
          <div className="col-xs-2 back-button">
            {this.state.step === 1 &&
            <Link to={'/wedding/manage'}>
              <i className="glyphicon glyphicon-menu-left" /> Back
            </Link>
            }
            {this.state.step === 2 &&
            <span onClick={this.getPreviousStep}>
              <i className="glyphicon glyphicon-menu-left" /> Back
            </span>
            }
          </div>
          <div className="col-xs-8">
            <h1>
              Your Website & App
            </h1>
          </div>
          <div className="col-xs-2 done-button">
            {this.state.step === 2 &&
              <button className="btn btn-primary" onClick={launchSuccessModal}>Done</button>
            }
          </div>
        </header>
        <div className="container-fluid main-content text-center">
          <span className="text-muted text-uppercase">Step {this.state.step} of 2</span>
          {this.state.step === 1 &&
            <div>
              <h4>
                Choose a theme. They&apos;re all beautiful...
              </h4>
              <em className="text-muted">You can change this at any time</em>
              <div className="text-left">
                <Themes forOnboard onSelect={this.getNextStep} />
              </div>
            </div>
          }
          {this.state.step === 2 &&
            <div>
              <h4>
                Add more things you can do with Zola. Anything you add shows up on both your website and mobile app.
              </h4>
              <div className="col-sm-12">
                <em className="text-muted">You can change this at any time</em>
              </div>
              <div className="col-sm-6 col-sm-offset-3">
                <PageListContainer />
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

WebsiteOnboard.propTypes = {
  getPages: PropTypes.func.isRequired,
  launchSuccessModal: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => (
  {
    getPages: () => dispatch(fetchPages()),
    launchSuccessModal: () => dispatch(showModal('WEBSITE_ONBOARD', { hideClose: true }))
  }
);

const WebsiteOnboardSuccessModal = (props) => {
  const { closeModal } = props;
  return (
    <div className="text-center">
      <div className="modal-header">
        <h1>Great!</h1>
        <h3>Now, let&apos;s setup the pages for your website & app.<br />We&apos;ll start with the homepage.</h3>
      </div>
      <div className="modal-body">
        <Link to={'/wedding/manage/website/pages'} onClick={closeModal} className="btn btn-primary">
          Next, setup Homepage
        </Link>
      </div>
    </div>
  );
};

WebsiteOnboardSuccessModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

const mapModalDispatchToProps = dispatch => (
  {
    closeModal: () => dispatch(hideModal())
  }
);

export const WebsiteOnboardSuccessModalContainer = connect(null, mapModalDispatchToProps)(WebsiteOnboardSuccessModal);

export default connect(null, mapDispatchToProps)(WebsiteOnboard);



/** WEBPACK FOOTER **
 ** ./src/components/onboard/WebsiteOnboard.jsx
 **/